<template>
  <div class="index">
    <div class="table-scroll mod" v-if="type === '1'" style="padding-top: 0.4rem;">
      <div class="table_first">
        <div class="date_box fl"><span>日期</span></div>
        <div class="right_box" id="rightTitle">
          <div>
            <span>收盘价</span>
            <span>涨跌幅</span>
            <span>北向资金持股量</span>
          </div>
        </div>
      </div>
        <div class="table-l fl">
          <table width="100%" cellspacing="0" cellpadding="0">
            <tr v-for="item in cgbdData" :key="item.id">
              <td>{{item.TRADEDATE}}</td>
            </tr>
          </table>
        </div>
        <div class="table-r" id="right">
          <div class="table-r-wrap2">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr v-for="item in cgbdData" :key="item.id">
                <td :class="item.TCLOSE">{{item.TCLOSE}}</td>
                <td :class="item.PCHG|formateRedGreen">{{item.PCHG}}%</td>
                <td :class="item.SHHKSHAREHOLD">{{item.SHHKSHAREHOLD | num(2,false,'')}}</td>
              </tr>
            </table>
          </div>
        </div>
    </div>
    <div class="table-scroll mod new-gd" v-if="type == '2'">
     <div class="table_last">
        <div class="date_box fl"><span>上榜日期</span></div>
        <div class="right_box" id="rightTitle">
          <div>
            <span>排名</span>
            <span>收盘价</span>
            <span>涨跌幅</span>
            <span>成交额</span>
          </div>
        </div>
      </div>
      <div class="table-l fl">
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr v-for="item in historyNorthData" :key="item.id">
            <td>{{item.TRADEDATE}}</td>
          </tr>
        </table>
      </div>
      <div class="table-r" id="right">
        <div class="table-r-wrap">
          <table width="100%" cellspacing="0" cellpadding="0">
            <tr v-for="item in historyNorthData" :key="item.id">
              <td :class="item.RANK">{{item.RANK}}</td>
              <td :class="item.TCLOSE">{{item.TCLOSE}}</td>
              <td :class="item.PCHG|formateRedGreen">{{item.PCHG}}%</td>
              <td :class="item.TOTALAMT">{{item.TOTALAMT| num(2, false, "元")}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- 港资机构持股 -->
    <div class="table-scroll mod scroll-jg" v-if="type == '3'" style="padding-top: 0.5rem;">
      <div class="table_last">
        <div class="date_box fl"><span>机构名称</span></div>
        <div class="right_box" id="rightTitle">
          <div>
            <span>持仓市值</span>
            <span>增持市值</span>
            <span>持股数</span>
            <span>持股变化</span>
            <span>变化占比</span>
          </div>
        </div>
      </div>
      <div class="table-l fl">
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr v-for="item in organizationList" :key="item.id">
            <td><div class="name-l" @click="goJiGaoDetail(item)">{{item.compname}}</div></td>
          </tr>
        </table>
      </div>
      <div class="table-r" id="right">
        <div class="table-r-wrap">
          <table width="100%" cellspacing="0" cellpadding="0">
            <tr v-for="item in organizationList" :key="item.id">
              <td>{{item.holdamt | num(2,false,'元')}}</td>
              <td>{{item.cbuyamt | num(2,false,'元')}}</td>
              <td>{{item.holdvol | num(2,false,'')}}</td>
              <td>{{item.holdchg | num(2,false,'')}}</td>
              <td :class="item.bdzb | formateRedGreen">{{item.bdzb | percent('%')}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { agcgbd , hkcjmx} from '@/api/index.js'
import {  getcgjg, getStkHolder } from '@/api/xqDetail.js'
import { getUrlQuery } from "@/utils/handleUrl.js"
export default {
  name: "ggMore",
  components: {},
  data() {
    return {
      // navs: [],
      type:0,// 判断显示详情类型
      stockCode:"",// 股票代码
      userToken:"",// 用户token
      version:"",// 客户端版本号
      cgbdData:[],// 持股变动数据
      historyNorthData:[],//成交榜数据
      organizationList:[],// 港资机构持股数据
      page: 1,
      pageSize: 20,
      queryShow:false,//判断请求是否完成
      allQuery:false,//判断是否已请求全部数据
    };
  },
  filters: {
    formateRedGreen:function (v) {
      if(v==undefined||v==null) return
      if(v>0) return 'ft-red'
      if(v<0) return 'ft-green'
    },
    num(value, fixed = 2, isZero, basis) {
      if (value) {
        if (!isNaN(value)) {
          value = Number(value);
          let len = parseInt(Math.abs(value), 10).toString().length;
          value = (len > 12 && value / 1000000000000) || (len > 8 && value / 100000000) || (len > 4 && value / 10000) || value;
          if (!isZero || (!/^[-+]?\d*$/.test(value.toString()) && value.toString().split(".")[1].length > fixed)) {
            value = value.toFixed(fixed);
          }
          value = (len > 12 && value + "万亿") || (len > 8 && value + "亿") || (len > 4 && value + "万") || value + basis;
        }
      } else if (value === 0) {
        value = "0.00";
      } else {
        value = "--";
      }
      return value;
    },
    percent(val,str){
      if(val || val === 0){
        let num = val * 100
        var multiple = Math.pow(10, 4);
        return (Math.round(num * multiple) / multiple).toFixed(4) + str;
      }else{
        return '--'
      }
    }
  },
  created() {
    this.type = getUrlQuery('id')
    this.stockCode = getUrlQuery('code')
    this.userToken = getUrlQuery('token')
    this.version = getUrlQuery('version')
  },
  mounted: function () {
    window.addEventListener('scroll', this.scrollChange, true);
    let right = document.getElementById("right");
    right.onscroll = function () {
      let right_left = this.scrollLeft;
      document.getElementById("rightTitle").scrollLeft = right_left;
    };
    if(this.type === '1'){
      document.title = "持股变动"
      this.getCgbd()
    }else if(this.type === '2'){
      document.title = "成交榜"
      this.getCjb();
    }else if(this.type === '3'){
      document.title = "港资机构持股"
      this.getDzcgjg();
    }
  },
  methods: {
     // 获取持股变动数据
    getCgbd:function(){
      let that = this
      if(that.queryShow) return;
      that.queryShow = true;
      let obj = {
        stock: that.stockCode,
        page: that.page,
        size: that.pageSize
      }
      agcgbd(obj).then(res=>{
        that.queryShow = false;
        if(res.data.err === 0){
          that.cgbdData = [...that.cgbdData ,...res.data.data.list];
          if(res.data.data.list.length < 20){
            that.allQuery = true;
          }
        }
      })
    },
    // 获取成交榜数据
    getCjb:function(){
      let that = this;
      if(that.queryShow) return;
      that.queryShow = true;
      let obj = {
        stock: that.stockCode,
        page: that.page,
        size: that.pageSize
      }
      hkcjmx(obj).then(res=>{
        that.queryShow = false;
        if(res.data.err === 0){
          that.historyNorthData = [...that.historyNorthData ,...res.data.data.list];
          if(res.data.data.list.length < 20){
            that.allQuery = true;
          }
        }
      })
    },
    // 获取港资机构持股
    getDzcgjg:function(){
      let that = this;
      if(that.queryShow) return;
      that.queryShow = true;
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      let type
      if(isiOS){
        type = 'ios'
      }else if(isAndroid){
        type = 'android'
      }
      let obj={
        httpdzh:that.version ? 'dzh-' + type +'-'+ that.version : '',
        stock: that.stockCode,
        token: that.userToken,
        pageNumber: that.page,
        pageSize: that.pageSize
      }
      getcgjg(obj).then(res=>{
        that.queryShow = false;
        if(res.data.err === 0){
          that.organizationList = [...that.organizationList ,...res.data.data.list];
          if(res.data.data.list.length < 20){
            that.allQuery = true;
          }
        }
      })
    },
    scrollChange () {
      let that = this;
      clearTimeout(this.timer);
      that.timer = setTimeout(function(){
        var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        if(scrollTop+windowHeight+70>=scrollHeight){
          if(!that.queryShow && !that.allQuery){
            that.page = that.page + 1
            that.$nextTick(()=>{
              if(that.type === '1'){
                that.getCgbd()
              }else if(that.type === '2'){
                that.getCjb()
              }else if(that.type === '3'){
                that.getDzcgjg()
              }
            })
          }
        }
      },200)
    },
    goJiGaoDetail:function(item){
      location.href = window.location.protocol+"//"+window.location.host + window.location.pathname + '#/jgdetail?code='+item.particode+"&DZHSPECIAL=265&name="+item.compname
    },
  },
  destroyed () {
    // 离开该页面需要移除这个监听的事件，不然会报错
    window.removeEventListener('scroll', this.scrollChange, true)
  }
};
</script>
